import IcFlagUnitedStates from '@interco/icons/core/misc/ic_flag_united_states'
import IcFlagArgentina from '@interco/icons/core/misc/ic_flag_argentina'

const accountIcons: Record<string, JSX.Element> = {
  'ga-ar': <IcFlagUnitedStates width={40} height={40} />,
  ar: <IcFlagArgentina width={40} height={40} />,
  default: <IcFlagUnitedStates width={40} height={40} />,
}

export const getAccountIcon = (icon?: string) => accountIcons[icon ?? 'default']
